<template>
  <section class="animation-and-qr">
    <!-- アニメーション -->
    <img class="animation" :src="animationUrl" />

    <div v-if="isValidQrString != null">
      <!-- QRコード(有効期間内) -->
      <vue-qrcode
        v-if="isValidQrString"
        class="qr"
        :value="qrString"
        tag="img"
      ></vue-qrcode>

      <!-- リロードボタン(有効期間外) -->
      <section v-else class="end-ticket">
        <div class="text">
          QRコードを<br />
          再取得する
        </div>
        <div class="button-reload">
          <button @click="onTapReload">
            <img src="@/assets/img/icon/svg/icon-reload.svg" />
          </button>
        </div>
      </section>
    </div>

    <!-- QR文字列読み込み中のレイアウト崩れ防止 -->
    <div v-else class="qr" />
  </section>
</template>

<script>
export default {
  name: "FaceAnimationAndQR",
  props: {
    animationUrl: {
      type: String,
      required: true,
    },
    isValidQrString: {
      type: Boolean,
      required: false,
      default: null,
    },
    qrString: {
      type: String,
      required: true,
    },
    onTapReload: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.animation-and-qr {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  width: 100%;
  height: 220px;
  margin: 0 0 24px;
  padding: 0;

  @media screen and (min-height: 760px) {
    margin: 0 0 60px;
  }
}
.animation-and-qr .animation {
  width: 65vw;
  height: 220px;
  object-fit: cover;
}
.animation-and-qr .qr {
  width: calc(35vw - 30px);
  height: calc(35vw - 30px);
  padding: 60px 15px;
}

.end-ticket {
  width: calc(35vw - 30px);
  padding: 60px 15px;
  text-align: center;
}
.end-ticket .text {
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
}
.end-ticket .button-reload {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 15px;
}
.end-ticket .button-reload button {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 25px;
  background-color: #ffda5f;
  box-shadow: var(--defaultBoxShadow);
}
.end-ticket .button-reload button img {
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 2px 0 0;
  border-radius: none;
  box-shadow: none;
}
</style>
